import React from 'react'

const MinimisedReturns = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#faab48"
                        d="M398.79 49.44c16.87 7.75 33.56 15.95 49.66 24.45 31.32 16.43 50.03 49.68 50.83 82.8 2.04 66.2 2.04 132.4 0 198.6-.8 33.13-19.51 66.37-50.83 82.8-51.55 27.3-108.15 50.64-159.96 68.51-20.99 7.19-43.63 7.19-64.63 0-51.81-17.86-108.41-41.2-159.96-68.51-31.33-16.43-50.03-49.68-50.83-82.8-2.04-66.2-2.04-132.4 0-198.6.8-33.13 19.5-66.37 50.83-82.8 51.55-27.29 108.14-50.63 159.96-68.5 21-7.19 43.63-7.19 64.63 0 15.53 5.39 31.39 11.18 47.44 17.43l62.87 26.62z"
                        opacity={1}
                        data-original="#faab48"
                    />
                    <path
                        fill="#f8c358"
                        d="M395.81 123.29c0-27.86-4.13-54.75-11.79-80.1l-48.1-20.37c-16.04-6.25-31.91-12.04-47.44-17.43-8.7-2.98-17.67-4.7-26.7-5.21h-11.23c-9.03.51-18 2.24-26.7 5.21C172.04 23.26 115.45 46.6 63.9 73.9c-31.33 16.43-50.03 49.68-50.83 82.8-2.04 66.2-2.04 132.4 0 198.6.2 8.49 1.59 16.98 4.06 25.19 31.57 12.54 66 19.45 102.04 19.45 152.79 0 276.65-123.86 276.65-276.65z"
                        opacity={1}
                        data-original="#f8c358"
                        className="hovered-path"
                    />
                    <path
                        fill="#ffffff"
                        d="M398.79 49.44C332.13 71 254.06 99.39 175.32 134.65c-15.47 6.9-25.88 22.07-26.43 38.68-1.23 37.96-1.6 77.22-1.11 115.97.06 5.3-6.36 7.5-9.61 3.33-8.32-10.65-16.48-21.22-24.42-31.63-1.29-1.69-3.54-2.15-5.3-1.09-6.18 3.68-12.26 7.31-18.22 10.89-3.34 1.99-7.45-.66-7.47-4.78-.2-38.62.77-77.36 2.83-114.9.87-15.84 10.81-30.74 25.5-37.96 75.52-37.3 156.09-67.77 224.83-90.32 0 0 27.88 9.57 62.87 26.62z"
                        opacity={1}
                        data-original="#ffffff"
                        className=""
                    />
                    <path
                        fill="#2ad352"
                        d="M386.53 282.72c-63.31 0-114.64 51.33-114.64 114.64S323.22 512 386.53 512s114.64-51.33 114.64-114.64-51.33-114.64-114.64-114.64z"
                        opacity={1}
                        data-original="#2ad352"
                    />
                    <path
                        fill="#ffffff"
                        d="m451.38 378.79-68.7 72.14a20.164 20.164 0 0 1-14.5 6.26h-.09c-5.45 0-10.67-2.21-14.46-6.12l-36.45-37.56c-7.75-7.99-7.56-20.75.43-28.5 7.98-7.75 20.74-7.56 28.49.43l21.85 22.51 54.24-56.96c7.68-8.06 20.43-8.38 28.49-.7 8.06 7.67 8.38 20.43.7 28.49z"
                        opacity={1}
                        data-original="#ffffff"
                        className=""
                    />
                </g>
            </svg>


        </>
    )
}

export default MinimisedReturns